import { removeHighlights } from '../../styles';
import { CONTROLS_BAR_HEIGHT } from '../../../../common/utils/common.constants';
import { TOP_BAR_HEIGHTS } from '../../controlsPlugin.constants';
import { PlayerSizesTypes } from '../../../../common/store/store.types';

interface StylesObject {
  bottomControlsWrapperStyle: { [key: string]: any }[];
  topControlsWrapperStyle: { [key: string]: any }[];
}

const bottomControlsWrapper = {
  position: 'absolute',
  bottom: 0,
  width: '100%',
  transition: 'all ease-in-out 0.4s',
  opacity: 1,
  transform: 'translateY(0)',
  hide: {
    transform: `translateY(${CONTROLS_BAR_HEIGHT}px)`,
  },
};
const topControlsWrapperStyle = {
  position: 'absolute',
  top: 0,
  width: '100%',
  transition: 'all ease-in-out 0.4s',
  opacity: 1,
  transform: 'translateY(0)',
  hide: {
    small: {
      transform: `translateY(-${TOP_BAR_HEIGHTS.SMALL})`,
    },
    mediumAndLarge: {
      transform: `translateY(-${TOP_BAR_HEIGHTS.MEDIUM_AND_LARGE})`,
    },
    extraLarge: {
      transform: `translateY(-${TOP_BAR_HEIGHTS.EXTRA_LARGE})`,
    },
  },
};

export const getFullVideoControlsStyleObject = (isVisible: boolean, playerSize: PlayerSizesTypes): StylesObject => {
  const smallSize = playerSize === 'small';
  const mediumOrLarge = playerSize === 'medium' || playerSize === 'large';
  const extraLargeSize = playerSize === 'extraLarge';
  return {
    bottomControlsWrapperStyle: [
      removeHighlights,
      bottomControlsWrapper,
      !isVisible && bottomControlsWrapper.hide,
    ],
    topControlsWrapperStyle: [
      removeHighlights,
      topControlsWrapperStyle,
      !isVisible && topControlsWrapperStyle.hide,
      !isVisible && smallSize && topControlsWrapperStyle.hide.small,
      !isVisible && mediumOrLarge && topControlsWrapperStyle.hide.mediumAndLarge,
      !isVisible && extraLargeSize && topControlsWrapperStyle.hide.extraLarge,
    ],
  };
};
